var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    {
      staticStyle: { width: "100%" },
      attrs: {
        "allow-create": !_vm.isSingapore,
        clearable: "",
        filterable: "",
        disabled: _vm.disabled,
      },
      on: {
        change: _vm.handleLocationChange,
        "visible-change": _vm.handleSelectVisibleChange,
      },
      model: {
        value: _vm.formattedLocationLevel,
        callback: function ($$v) {
          _vm.formattedLocationLevel = $$v
        },
        expression: "formattedLocationLevel",
      },
    },
    _vm._l(
      _vm.isSingapore ? _vm.sgpLocationList : _vm.otherLocationList,
      function (location) {
        return _c(
          "el-option",
          {
            key: location.key,
            attrs: { label: location.label, value: location.value },
          },
          [
            !_vm.isSingapore
              ? _c("div", {}, [
                  _c("span", [_vm._v(_vm._s(location.label))]),
                  _c(
                    "span",
                    { staticStyle: { cursor: "pointer", float: "right" } },
                    [
                      _c("em", {
                        staticClass: "el-icon-remove",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.deleteLocation(location.key)
                          },
                        },
                      }),
                    ]
                  ),
                ])
              : _vm._e(),
          ]
        )
      }
    ),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }